module.exports = __webpack_public_path__ + "static/media/employees-import.023679c1.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/employees-import.csv
// module id = ./src/assets/employees-import.csv
// module chunks = 11